import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {CyclesReturns} from "#material/sockets/cycles"
import {threeConvert, threeRGBColor} from "#material/three/three-utils"
import {registerMaterialGraphNode} from "#material/register"
import type {ColorSockets} from "#material/nodes/input/color/definition"
import {colorDefinition} from "#material/nodes/input/color/definition"
import type {ThreeEvaluator, CyclesEvaluator} from "#material/nodes/base/material/types/evaluators"
import {cyclesColor} from "#material/cycles/helpers"
import type {ThreeReturns} from "#material/sockets/three"
import type {ColorNode} from "#material/cycles/types"

@registerMaterialGraphNode
export class Color extends MaterialNode<ColorSockets> {
    public override get definition() {
        return colorDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<ColorSockets>> => {
        const color = threeConvert(this.parameters.settings.color, threeRGBColor) ?? threeRGBColor({r: 0, g: 0, b: 0})
        return {color}
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<ColorSockets>> => {
        const colorNode: ColorNode = {
            type: "color",
            inputs: {},
            parameters: {value: cyclesColor(this.parameters.settings.color)},
            resources: {},
        }

        return {color: [colorNode, "color"]}
    }
}
